import React, { useEffect, useState, useCallback, useContext, useRef } from "react";
import api, { BASE_URL } from "../../Utils/api";
import IndicesCorrecaoModal from "./IndicesCorrecaoModal"; // Certifique-se de que o caminho está correto
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import { Badge } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../../Utils/GlobalContext";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";


function IndicesCorrecao() {
  const { toast, confirm } = useFeedback();
  const [indicesCorrecao, setIndicesCorrecao] = useState([]);
  const [selectedIndice, setSelectedIndice] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const token = localStorage.getItem("authToken");
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");
  const exclusoesEmAndamento = useRef(new Set());
  const permiteEdicao = "N"; // Ajuste para "S" ou "N" , de Configurações ou Cadastros Globais de qualquer entidade

  // Definindo as colunas da tabela
  const columns = [
   // { Header: "ID", accessor: "id" },
    { Header: "Nome", accessor: "nome" },
    {
      Header: "Situação",
      accessor: "ativo",
      Cell: ({ row }) => (
        <Badge bg={row.ativo === "S" ? "success" : "secondary"} pill>
          {row.ativo === "S" ? "Ativo" : row.ativo === "N" ? "Inativo" : "—"}
        </Badge>
      ),
    },
  ];

  // Função para buscar os índices de correção
  const fetchIndicesCorrecao = useCallback(() => {
    api
      .get(`${BASE_URL}/api/indicesCorrecao/ListarIndicesCorrecao/${entidadeID}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Adiciona `permiteEdicao` a cada item retornado
        const indicesComPermissao = response.data.data.map((indice) => ({
          ...indice,
          permiteEdicao: permiteEdicao, // adiciona a permissão para cada item
        }));
        setIndicesCorrecao(indicesComPermissao);
      })
      .catch((error) => {
        console.error("Erro ao buscar os índices de correção:", error);
      });
  }, [token, entidadeID, permiteEdicao]);


  // Função para buscar os dados da API na montagem do componente
  useEffect(() => {
    fetchIndicesCorrecao();
  }, [fetchIndicesCorrecao]);

  const handleEdit = (indice) => {
    setSelectedIndice(indice);
    setShowModal(true); // Abrir o modal para edição
  };

  const handleAdd = () => {
    setSelectedIndice(null); // Limpar o índice selecionado para adicionar novo
    setShowModal(true); // Abrir o modal para novo índice
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedIndice(null);
  };

  const handleExcluir = async (indice) => {
    if (exclusoesEmAndamento.current.has(indice.id)) return;
    exclusoesEmAndamento.current.add(indice.id);

    try {
      const ok = await confirm(`Tem certeza que deseja excluir o índice "${indice.nome}"?`);
      if (!ok) return;

      await api.delete(
        `${BASE_URL}/api/indicesCorrecao/ExcluirIndiceCorrecao/${indice.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchIndicesCorrecao();
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error(error.response.data?.message || "Este índice de correção está sendo utilizado.");
        return;
      }

      console.error("Erro ao excluir índice:", error);
      toast.error(error.response?.data?.message || "Erro ao excluir. Tente novamente.");
    } finally {
      exclusoesEmAndamento.current.delete(indice.id);
    }
  };

  return (
    <div>
      <PageHeader titulo="Cadastro de Índices de Correção" path="/IndicesCorrecao" />

      <GridPadrao
        columns={columns}
        data={indicesCorrecao}
        onEdit={(configuracao) => handleEdit(configuracao, permiteEdicao)}
        onAdd={handleAdd}
        addDataTour="indices-correcao-adicionar"
        onInactivate={handleExcluir}
        defaultFilters={{ filters: {} }}
      />

      {/* Modal para adicionar/editar índice de correção */}
      <IndicesCorrecaoModal
        show={showModal}
        handleClose={handleClose}
        indice={selectedIndice}
        fetchIndicesCorrecao={fetchIndicesCorrecao}
      />
    </div>
  );
}

export default IndicesCorrecao;
